import { createReducer } from '@reduxjs/toolkit'

import { searchClassBanners } from './classBannerSearch.actions'
import { logout } from '../user/user.action'
import { createSelector } from 'reselect'

const initialState = {
  classBanners: [],
  classBannersPage: 0,
  classBannersPageSize: 0,
  classBannersTotal: 0,

  loading: {
    searchClassBanners: false,
  },
  error: {
    searchClassBanners: false,
  },
}

const classBannerSearchReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(searchClassBanners.fulfilled, (state, action) => {
      state.classBanners = action.payload?.results || []
      state.classBannersPage = action.payload?.page
      state.classBannersTotal = action.payload?.total
      state.classBannersPageSize = action.payload?.page_size

      state.loading.searchClassBanners = false
      state.error.searchClassBanners = false
    })
    .addCase(searchClassBanners.pending, (state) => {
      state.loading.searchClassBanners = true
      state.error.searchClassBanners = false
    })
    .addCase(searchClassBanners.rejected, (state) => {
      state.loading.searchClassBanners = false
      state.error.searchClassBanners = true
    })

    .addCase(logout.fulfilled, () => initialState)

    .addDefaultCase((state) => state)
})

export const classBannerSearchState = (state) => state.classBannerSearch

export const selectClassBannerPagination = createSelector(
  classBannerSearchState,
  ({ classBanners, classBannersPage, classBannersTotal, classBannersPageSize }) => ({
    classBanners,
    classBannersPage,
    classBannersTotal,
    classBannersPageSize,
  })
)

export const selectClassBannerLoading = createSelector(
  classBannerSearchState,
  ({ loading: { searchClassBanners } }) => searchClassBanners
)

export const selectClassBannerError = createSelector(
  classBannerSearchState,
  ({ error: { searchClassBanners } }) => searchClassBanners
)

// Keep the old selectors for backward compatibility
export const selectSearchJobsPagination = selectClassBannerPagination
export const selectSearchJobsLoading = selectClassBannerLoading

export default classBannerSearchReducer
